import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as BoxedAddIcon } from '../../../assets/icons/boxed-add-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-icon.svg';
import { ReactComponent as DocumentIcon } from '../../../assets/icons/document-icon-white.svg';
import { ReactComponent as Model3dIcon } from '../../../assets/icons/model-3d-icon-white.svg';
import {
    MODELS_EXTENSIONS,
    MODELS_MAX_SIZE,
} from '../../../constants/file.constants';
import { replaceAttachmentStart } from '../../../store/attachment/attachment.action';
import { closeDialog } from '../../../store/dialog/dialog.action';
import { setIsError } from '../../../store/error/error.action';
import { getNodeStart } from '../../../store/node/node.action';
import { selectNodeSelected } from '../../../store/node/node.selector';
import {
    FlexBoxFullWHColumn,
    FlexBoxFullWRowBetween,
} from '../../layout/layout.styles';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import {
    ReplaceBox,
    TextArea,
    TextAreaLabel,
} from './dialog-replace-attachment.styles';

const DialogReplaceAttachment = ({ inputData }: { inputData: any }) => {
    const nodeSelected = useSelector(selectNodeSelected);

    const dispatch = useDispatch();

    const [fileUploaded, setFileUploaded] = useState<File | null>(null);

    const type: 'document' | 'model3d' = inputData.type;
    const title1 =
        type === 'document'
            ? 'Sostituisci documento'
            : 'Sostituisci modello 3D';
    const title2 = `rifiutato da ${inputData.rejected_by}`;
    const title = `${title1} ${title2}`;

    const handleReplace = () => {
        if (!fileUploaded) {
            dispatch(setIsError(true, 'File non caricato'));
            return;
        }
        dispatch(
            replaceAttachmentStart(
                inputData.id,
                inputData.type,
                fileUploaded,
                () => {
                    dispatch(closeDialog());
                    dispatch(getNodeStart(nodeSelected!.id));
                }
            )
        );
    };

    const handleFileChange = (event: any) => {
        const files = event.target.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.size > MODELS_MAX_SIZE.value) {
                dispatch(
                    setIsError(
                        true,
                        'Il file è troppo grande, il limite massimo è  ' +
                            MODELS_MAX_SIZE.label
                    )
                );
                return;
            }
            const extension = file.name.split('.').pop();
            if (type === 'model3d' && extension !== 'zip') {
                dispatch(
                    setIsError(
                        true,
                        `Estensioni supportate: ${Object.values(
                            MODELS_EXTENSIONS
                        ).join(', ')}`
                    )
                );
                return;
            }
            setFileUploaded(file);
            event.target.value = '';
        }
    };

    return (
        <Fragment>
            <DialogTitle title={title} />
            <DialogContent>
                <FlexBoxFullWHColumn>
                    <TextAreaLabel style={{ marginBottom: '8px' }}>
                        MOTIVAZIONE
                    </TextAreaLabel>
                    <TextArea
                        fullWidth
                        multiline
                        disabled
                        defaultValue={inputData.refusal_notes}
                    />
                    <Box my={1} />
                    <FlexBoxFullWRowBetween alignItems={'end'} mb={1}>
                        <TextAreaLabel>SOSTITUISCI</TextAreaLabel>
                        <Typography component={'label'} height={30}>
                            <BoxedAddIcon
                                style={{
                                    cursor: 'pointer',
                                    width: '30px',
                                    height: '100%',
                                    verticalAlign: 'middle',
                                }}
                            />
                            <input
                                type="file"
                                hidden
                                onChange={handleFileChange}
                            />
                        </Typography>
                    </FlexBoxFullWRowBetween>
                    <ReplaceBox>
                        {fileUploaded && (
                            <FlexBoxFullWRowBetween
                                alignItems={'center'}
                                mx={2}
                            >
                                <Box display={'flex'} alignItems={'center'}>
                                    {type === 'document' ? (
                                        <DocumentIcon />
                                    ) : (
                                        <Model3dIcon />
                                    )}
                                    <Box mx={1} />
                                    <Typography>{fileUploaded.name}</Typography>
                                </Box>
                                <DeleteIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setFileUploaded(null)}
                                />
                            </FlexBoxFullWRowBetween>
                        )}
                    </ReplaceBox>
                    <Box my={1} />
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '15px',
                            color: 'info.main',
                            fontWeight: 'bold',
                            width: '206px !important',
                            alignSelf: 'end',
                            lineHeight: '1.5',
                        }}
                        onClick={handleReplace}
                    >
                        CARICA SOSTITUZIONE
                    </Button>
                </FlexBoxFullWHColumn>
            </DialogContent>
        </Fragment>
    );
};

export default DialogReplaceAttachment;
